var pagination = {
	backwardText: "página anterior",
	forwardText: "próxima página",
	pageRangeText: "Página {current} de {total}",
	itemsPerPageText: "Itens por página",
	itemRangeText: "{start}-{end} de {total} itens",
	pageNumberText: "página atual"
};
var searchPlaceholder = "Buscar...";
var ptTranslations = {
	pagination: pagination,
	searchPlaceholder: searchPlaceholder
};

export { ptTranslations as default, pagination, searchPlaceholder };
